let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3L1uC")).then(() => parcelRequire('akCro'));